import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-remax',
  templateUrl: './remax.component.html',
  styleUrls: ['./remax.component.css']
})
export class RemaxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
